window.PflegeboxAPI = {
    async createCustomer(customerData, signatureUrl) {
        console.log('----Creating Customer----', JSON.stringify(customerData));
        const response = await fetch('/admin/api/2024-01/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Access-Token': window.shopifyConfig.accessToken
            },
            body: JSON.stringify({
                query: `
                    mutation customerCreate($input: CustomerInput!) {
                        customerCreate(input: $input) {
                            customer {
                                id
                                email
                            }
                            userErrors {
                                field
                                message
                            }
                        }
                    }
                `,
                variables: {
                    input: {
                        firstName: customerData.firstName,
                        lastName: customerData.lastName,
                        email: customerData.email || `${customerData.firstName}.${customerData.lastName}@temp.com`,
                        phone: customerData.phone,
                        addresses: [{
                            address1: `${customerData.street} ${customerData.number}`,
                            city: customerData.city,
                            zip: customerData.zip,
                            country: "DE"
                        }],
                        metafields: [
                            {
                                namespace: "pflegebox",
                                key: "care_level",
                                value: customerData.careLevel,
                                type: "single_line_text_field"
                            },
                            {
                                namespace: "pflegebox",
                                key: "signature",
                                value: signatureUrl,
                                type: "url"
                            }
                        ]
                    }
                }
            })
        });

        const data = await response.json();
        if (data.errors || data.data.customerCreate.userErrors.length > 0) {
            throw new Error('Customer creation failed');
        }
        return data.data.customerCreate.customer;
    },

    async createOrder(customerId, products) {
        const response = await fetch('/admin/api/2024-01/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Access-Token': window.shopifyConfig.accessToken
            },
            body: JSON.stringify({
                query: `
                    mutation draftOrderCreate($input: DraftOrderInput!) {
                        draftOrderCreate(input: $input) {
                            draftOrder {
                                id
                            }
                            userErrors {
                                field
                                message
                            }
                        }
                    }
                `,
                variables: {
                    input: {
                        lineItems: products.map(p => ({
                            variantId: p.id,
                            quantity: p.quantity
                        })),
                        customerId: customerId,
                        tags: ['Pflegebox']
                    }
                }
            })
        });

        const data = await response.json();
        if (data.errors || data.data.draftOrderCreate.userErrors.length > 0) {
            throw new Error('Order creation failed');
        }
        return data.data.draftOrderCreate.draftOrder;
    },

    async uploadSignatureFile(signatureData) {
        const base64Response = await fetch(signatureData);
        const blob = await base64Response.blob();
        
        const formData = new FormData();
        formData.append('file', blob, 'signature.png');

        const response = await fetch('/admin/api/2024-01/files.json', {
            method: 'POST',
            headers: {
                'X-Shopify-Access-Token': window.shopifyConfig.accessToken
            },
            body: formData
        });

        if (!response.ok) {
            throw new Error('Signature upload failed');
        }

        const fileData = await response.json();
        return fileData.file.url;
    }
};